import {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
  useMemo,
} from "react";
import MailInbox from "../MailInbox";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import WhatsApps from "../Whatsapp";
import services from "../../services";
import Header from "../Header";
import { socket } from "../../socket";
import { toast } from "react-toastify";
import Select from "react-select";
import TaskData from "../Task/TaskData";
import axios, { all } from "axios";
import TaskDataUI from "../Task/TaskDataUI";
import DateSidebarModal from "../../common/DateSidebarModal";
import DOMPurify from "dompurify";
import AddContactModal from "./AddContactModal";
import AddGroupModal from "./AddGroupModal";
import { MdAdd } from "react-icons/md";
import { MultiSelect } from "react-multi-select-component";
import ComposeEmail from "../composeEmail/ComposeEmail";
import AppModal from "../../common/AppModal";
import { FiMail, FiChevronLeft, FiChevronRight, FiCopy } from "react-icons/fi";
import { Modal } from "react-bootstrap";
import { useSelect } from "@material-tailwind/react";
import { useSelector } from "react-redux";
import { userDataLocal } from "../../utils/LocalSt";
import { useDispatch } from "react-redux";
import { whatsaapActiveTab } from "../../Redux/slice";
import { gmailSocket } from "../../socket";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/Localstorage/localStorageUtils";
import InternalNotes from "./InternalNotes";
import { LabelList } from "../../common/LabelList";
import labelService from "../../services/labelService";
import { MessageThread } from "./MessageThread";
import ConversationTab from "./ConversationTab";
import { buildColumnNavList, getNavCacheKey, readCachedNavList, writeCachedNavList } from "../../utils/ticketNav";
import Loading from "../../utils/Loading";
const PdfIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ marginRight: 8 }}>
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="6"
      fill="#fff"
      stroke="#d1d5db"
      strokeWidth="1.5"
    />
    <rect x="2" y="12" width="28" height="10" rx="2" fill="#e53935" />
    <text
      x="16"
      y="20"
      textAnchor="middle"
      fill="#fff"
      fontWeight="bold"
      fontSize="10"
      fontFamily="Arial"
    >
      PDF
    </text>
  </svg>
);

function Whatsapp({ taskDetails, parentOrigin }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const supportIdParam = searchParams.get("supportId");
  const isArchivedView = location.state?.isformArchivedView || false;
  const isLabel = location?.state?.labelType;
  const isMember = location?.state?.isMember;
  const selectedLabelId = location?.state?.selectedLabelId;
  const AllMail = location?.state?.AllMail;
  const AllMailPage = location?.state?.AllMailPage;
  const selectedActiveTab = useSelector((state) => state?.redux);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationality, setNationality] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [preExistingMedicalConditions, setPreExistingMedicalConditions] =
    useState("");
  const [isWhatsappTask, setIsWhatsappTask] = useState(false);
  const [isEmailappTask, setIsEmailappTask] = useState(false);
  const [collisionWarning, setCollisionWarning] = useState(null);
  const [selectedTab, setSelectedTab] = useState(() => {
    if (supportIdParam) {
      return "CONVERSATION";
    }
    if (location?.state?.selectedMail?.taskType === "Whatsapp") {
      return "WHATSAPP";
    } else if (location?.state?.selectedMail?.taskType === "Gmailboard") {
      return "GMAIL_BOARD";
    } else {
      return "GMAIL";
    }
  });




  const [selectedEmailID, setSelectedEmailID] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState({});
  const [dataById, setDataById] = useState({});
  const [profileId, setProfileId] = useState("");
  const [clientId, setClientId] = useState();
  const [chatData, setChatData] = useState([]);
  const [senderBy, setSenderBy] = useState("");
  const [recivedBy, setRecivedBy] = useState("");
  const [taskData, setTaskData] = useState([]);
  const [selectedContactTaskData, setSelectedContactData] = useState([]);
  const [gender, setGender] = useState("");
  const { id } = useParams();
  const labelType = location.state?.labelType || null;
  const [selectedMail, setSelectedMail] = useState(
    location.state?.selectedMail || null
  );
  const { activeButton } = location.state || {};
  const [labelAnchorEl, setLabelAnchorEl] = useState(null);
  const [labelObjects, setLabelObjects] = useState([]);

  const [isSend, setIsSend] = useState(false)
  const [labelname, setLabelname] = useState([])
  const [labelIds, setLabelIds] = useState([])
  const initialTaskId = location.state?.taskID || location.state?.currentTask?.id || null;
  const [selectedtaskID, setSelectedtaskID] = useState(initialTaskId);
  const deadlineDate = location.state?.deadlineDate;
  const openTaskDataSidebar = location.state?.openTaskDataSidebar || false;
  const [currentTask, setCurrentTask] = useState(
    location.state?.currentTask || null
  );
  const taskDataProps = location.state?.taskDataProps || {};
  const board = getLocalStorageItem("board");
  const boardId = board?.value;
  const [activeTab, setActiveTab] = useState(
    selectedActiveTab?.whatsappActiveTag || "contact"
  );




  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState(null);
  const [groupContacts, setGroupContacts] = useState([]);
  const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);
  const [whatsappprofile, setWhatsappProfile] = useState([]);
  const [selectedprofiles, setSelectedProfiles] = useState([]);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [showAddGroupModal, setShowAddGroupModal] = useState(false);
  const [mergedArray, setMergedArray] = useState([]);
  const hasFetchedTaskRef = useRef(false);
  // Gates the whole detail page behind a spinner until the primary task record
  // (getTaskById below) has resolved, instead of rendering the layout immediately
  // and letting fields pop in as each API call finishes.
  const [isPageLoading, setIsPageLoading] = useState(true);
  const navigate = useNavigate();
  const senderByRef = useRef(senderBy);
  const recivedByRef = useRef(recivedBy);
  const [sessionId, setSessionId] = useState(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const chatContainerRef = useRef(null);
  const [isSocketConnected, setIsSocketConnected] = useState(false);
  const reconnectTimeoutRef = useRef(null);
  const apiCallTimeoutRef = useRef(null);
  const lastMessageRef = useRef(null);
  const [sendingMessages, setSendingMessages] = useState(new Set());
  const refreshTimeoutRef = useRef(null);
  const messageRefreshTimeoutRef = useRef(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [composeStatus, setComposeStatus] = useState(false);
  const [selectedEmailData, setSelectedEmailData] = useState("");
  const isLoadingRef = useRef(false);
  const [loading, setLoading] = useState(false);
  // Separate from `loading` (which nothing currently reads for the body area) —
  // drives a spinner over the email content while handlegetEmailDetails is
  // in flight, since an Outlook message's body can take seconds to arrive.
  const [emailBodyLoading, setEmailBodyLoading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [allattachmentsPathData, setAllAttachmentPathData] = useState([]);
  const [isAddingContact, setIsAddingContact] = useState(false);
  const [attachmentTab, setAttachmentTab] = useState("ALL");
  const [getemailbyid, setgetEmailData] = useState("");
  const [formattedBody, setFormattedBody] = useState([]);
  const [mailContent, setMailContent] = useState("");
  const [attachmentsPath, setAttachmentPath] = useState([]);
  const [threadData, setThreadData] = useState([]);
  const [currentTaskId, setCurrentTaskId] = useState(initialTaskId);
  const [boardListId, setBoardListId] = useState();
  const [selectedEmailId, setSelectedEmailId] = useState(null);
  const [groupSenderBy, setGroupSenderBy] = useState(null);
  const [showAttachement, setShowAttachement] = useState(false);
  const [showSender, steShowSender] = useState(false);
  const [isAbsolute, setIsAbsolute] = useState(false);
  const [showAllAttachment, setShowAllAttachment] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const boardIdParam = searchParams.get("boardId");

  const handleRefreshTask = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  // Previous/Next ticket navigation — respects whichever board column, filters,
  // and assignee the ticket was opened from (see Column.js's handleTaskDetailPopup).
  const navContext = location.state?.navContext || null;
  const [navTasks, setNavTasks] = useState(location.state?.navTasks || []);
  const [navComplete, setNavComplete] = useState(location.state?.navComplete || false);
  const [navLoading, setNavLoading] = useState(false);
  const navIndex = navTasks.findIndex((t) => String(t.id) === String(id));
  const navTotal = navTasks.length;

  useEffect(() => {
  
    if (navComplete && navIndex !== -1) return;
    if (!navContext?.boardId || !navContext?.columnId) return;

    // location.state (and navComplete with it) is lost on a hard reload or a
    // browser back/forward hop, which would otherwise force the heavy
    // getAllTask(boardId) call to run again on every such navigation. Fall
    // back to the session cache built by the last successful fetch first,
    // unless that cache doesn't contain the current task.
    const cacheKey = getNavCacheKey(navContext);
    const cached = readCachedNavList(cacheKey);
    if (cached && cached.length > 0 && cached.some((t) => String(t.id) === String(id))) {
      setNavTasks(cached);
      setNavComplete(true);
      return;
    }

    let cancelled = false;
    setNavLoading(true);
    buildColumnNavList(navContext).then((fullList) => {
      if (cancelled || fullList.length === 0) return;
      setNavTasks(fullList);
      setNavComplete(true);
    }).finally(() => {
      if (!cancelled) setNavLoading(false);
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToNavIndex = (targetIndex) => {
    if (targetIndex < 0 || targetIndex >= navTasks.length) return;
    const cached = navTasks[targetIndex];
    if (!cached?.id) return;

    // Navigate immediately with the cached snapshot instead of blocking on a
    // refetch first — the detail page refetches the full task on mount anyway,
    // so waiting here only delayed the click with no benefit to what's shown.
    navigate(`/detail/${cached.id}`, {
      replace: true,
      state: {
        ...location.state,
        selectedMail: cached,
        taskID: cached.id,
        currentTask: cached,
        navTasks,
        navComplete,
        navContext,
      },
    });

    // navTasks holds a snapshot captured when the nav list was built, so it can
    // go stale the moment a field (e.g. assignee) is edited on any ticket in it.
    // Refresh it in the background so Prev/Next stays accurate for later clicks,
    // without making this click wait on it.
    services.task.GET_TASK_BY_ID(cached.id)
      .then((response) => {
        if (!response?.data?.data) return;
        const target = { ...cached, ...response.data.data };
        const refreshedNavTasks = navTasks.map((t) => (t.id === target.id ? target : t));
        writeCachedNavList(getNavCacheKey(navContext), refreshedNavTasks);
      })
      .catch((error) => {
        console.error("Error refreshing ticket after navigation:", error);
      });
  };

  const goToPreviousTicket = () => goToNavIndex(navIndex - 1);
  const goToNextTicket = () => goToNavIndex(navIndex + 1);

  // Archiving a ticket removes it from the active list, so the "X of Y" pill
  // and Prev/Next must reflect that immediately (no manual refresh), and the
  // workflow should land the user straight on the next ticket instead of
  // bouncing them back to the board list.
  const handleTicketArchived = (archivedItem) => {
    const archivedId = String(archivedItem?.id ?? id);
    if (navTasks.length === 0 || navIndex === -1) {
      navigate("/app");
      return;
    }

    const remaining = navTasks.filter((t) => String(t.id) !== archivedId);
    writeCachedNavList(getNavCacheKey(navContext), remaining);
    setNavTasks(remaining);

    if (remaining.length === 0) {
      navigate("/app");
      return;
    }

    // The ticket that occupied navIndex+1 now sits at navIndex once the
    // archived one is spliced out; if the archived ticket was last in the
    // list, fall back to the new last ticket instead.
    const nextIndex = Math.min(navIndex, remaining.length - 1);
    const nextTask = remaining[nextIndex];
    if (!nextTask?.id) {
      navigate("/app");
      return;
    }

    navigate(`/detail/${nextTask.id}`, {
      replace: true,
      state: {
        ...location.state,
        selectedMail: nextTask,
        taskID: nextTask.id,
        currentTask: nextTask,
        navTasks: remaining,
        navComplete,
        navContext,
      },
    });

    services.task.GET_TASK_BY_ID(nextTask.id)
      .then((response) => {
        if (!response?.data?.data) return;
        const target = { ...nextTask, ...response.data.data };
        const refreshedNavTasks = remaining.map((t) => (t.id === target.id ? target : t));
        writeCachedNavList(getNavCacheKey(navContext), refreshedNavTasks);
      })
      .catch((error) => {
        console.error("Error refreshing ticket after navigation:", error);
      });
  };

  const handleSaveAndNext = () => {
    // Individual fields on this page autosave on blur/change already; blurring
    // whatever is focused flushes any pending edit before moving to the next ticket.
    if (document.activeElement && typeof document.activeElement.blur === "function") {
      document.activeElement.blur();
    }
    goToNextTicket();
  };




  useEffect(() => {
    if (!boardIdParam) return;
    const existingBoard = getLocalStorageItem("board");
    if (existingBoard?.value !== boardIdParam) {
      setLocalStorageItem("board", {
        ...(existingBoard && typeof existingBoard === "object" ? existingBoard : {}),
        value: boardIdParam,
      });
    }
  }, [boardIdParam]);
  const handleFirstNameChange = (e) => setFirstName(e.target.value);
  const handlegenderChange = (e) => setGender(e.target.value);
  const handleLastNameChange = (e) => setLastName(e.target.value);
  const handleNationalityChange = (e) => setNationality(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePhoneChange = (e) => setPhone(e.target.value);
  const handleDateOfBirthChange = (e) => setDateOfBirth(e.target.value);
  const handlePreExistingMedicalConditionsChange = (e) =>
    setPreExistingMedicalConditions(e.target.value);
  const dispatch = useDispatch();
  const userDataRaw = getLocalStorageItem("userData");
  let userData;
  if (typeof userDataRaw === "string") {
    try {
      userData = JSON.parse(userDataRaw);
    } catch {
      userData = null;
    }
  } else {
    userData = userDataRaw;
  }
  function findLabelByPath(labels, path, parentPath = "") {
    for (const label of labels) {
      const currentPath = parentPath
        ? `${parentPath}/${label.name}`
        : label.name;
      if (currentPath === path) return label;
      if (label.children) {
        const found = findLabelByPath(label.children, path, currentPath);
        if (found) return found;
      }
    }
    return null;
  }

  function findLabelsWithEmail(labels, emailID, parentPath = "") {
    let result = [];

    for (const label of labels) {
      const currentPath = parentPath ? `${parentPath}/${label.name}` : label.name;


      if (Array.isArray(label.emailId) && label.emailId.includes(emailID)) {
        result.push(currentPath);
      }


      if (label.children && label.children.length > 0) {
        result = result.concat(findLabelsWithEmail(label.children, emailID, currentPath));
      }
    }
    return result;
  }
  const flattenLabels = (labels, parentPath = "") => {
    let result = [];
    for (const label of labels) {
      const path = parentPath ? `${parentPath}/${label.name}` : label.name;
      result.push(path);
      if (label.children && label.children.length > 0) {
        result = result.concat(flattenLabels(label.children, path));
      }
    }
    return result;
  };
  async function fetchLabels(emailId) {
    setLoading(true);
    try {
      const res = await labelService.GET_Label_ALL();
      const fetchedLabels = res.data?.labels || [];
      setLabelObjects(fetchedLabels);

      const flattened = flattenLabels(fetchedLabels);

      const preSelected = findLabelsWithEmail(fetchedLabels, emailId);
      await handleApply(fetchedLabels, emailId)

    } catch (error) {
      console.error("Error fetching labels:", error);
    } finally {
      setLoading(false);
    }
  }
  async function handleApply(labelObjects, emailId) {
    if (labelname.length === 0) return;
    try {

      for (const labelPath of labelname) {
        const labelObj = findLabelByPath(labelObjects, labelPath);
        if (!labelObj) continue;
        const res = await labelService.GET_Label_By_Id(labelObj.id);
        const fullLabel = res.data.data;
        if (!fullLabel) continue;

        const payload = {
          name: labelPath.split("/").pop(),
          color: "#FF0000",
          emailId: [emailId],
        };
        await labelService.Update_Label_By_Id(labelObj.id, payload);
      }

      if (currentTaskId) {
        try {
          const data = await task.UPDATE_TASK(currentTaskId, { isLabel: true, labelID: selectedLabelId });
          setIsSend(false)

        } catch (err) {
          console.error("Error updating task:", err);
        }
      }

      setLabelname([]);
      handleClose();
    } catch (error) {
      console.error("Error applying labels:", error);
    } finally {
    }
  }

  const handleClick = () => {

    setIsAbsolute(true);

    setTimeout(() => {
      setIsAbsolute(false);
    }, 2000);
  };
  const updateTaskMail = async (id, dedlineData) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`,
        {
          deadline: dedlineData,
          taskStatus: "updated",
          title: currentTask?.title,
          gmailMessageId: currentTask?.gmailMessageId,
          userId: currentTask?.userId,
        }
      );
      if (response) {
      }
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };

  const getTaskMail = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/task/getAllTask`
      );
      if (response) {
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };



  const setTaskDetailModal = (show) => { };

  const addMessageToChat = (newMessage) => {
    setChatData((prevChatData) => {
      let updatedChatData = [...(prevChatData || [])];

      if (newMessage.id && newMessage.clientId) {
        updatedChatData = updatedChatData.map((msg) =>
          msg.clientId === newMessage.clientId ? newMessage : msg
        );
      } else {
        const messageExists = updatedChatData.some(
          (msg) =>
            (newMessage.id && msg.id === newMessage.id) ||
            (newMessage.clientId && msg.clientId === newMessage.clientId) ||
            (msg.message === newMessage.message &&
              (msg.time || msg.createdAt) ===
              (newMessage.time || newMessage.createdAt))
        );

        if (!messageExists) {
          updatedChatData.push(newMessage);
        }
      }

      return updatedChatData.sort((a, b) => {
        const timeA = a.time || new Date(a.createdAt).getTime() || 0;
        const timeB = b.time || new Date(b.createdAt).getTime() || 0;
        return timeA - timeB;
      });
    });
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const encodedProps = query.get("props");

    if (encodedProps) {
      const decodedProps = decodeURIComponent(encodedProps);
      const parsedProps = JSON.parse(decodedProps);
      linkData(parsedProps?.linkId);
    }
  }, [location.search]);

  const linkData = async (linkId) => {
    try {
      const response = await services.task.GET_TASK_LINK_DATA(linkId);
      const data = response?.data?.data;

      if (data) {
        setSelectedEmail(data?.task);
        setSelectedEmailId(data?.task?.gmailMessageId);
        handlegetEmailDetails(data?.task?.gmailMessageId);
        setCurrentTask(data?.task);
        getTaskById(data?.task?.id);
        setSelectedMail(data?.task);
        handleContactSelect(data?.task?.contactId);
        setSelectedContact(data?.task?.contactId);
        setSelectedtaskID(data?.task?.id);
        setCurrentTaskId(data?.taskId);
        setSele;
      }
    } catch (error) {
      console.error(error, "error");
    }
  };


  const getTaskById = async (id) => {
    if (!id) {
      setIsPageLoading(false);
      return null;
    }
    try {
      const extraHeaders = {
        "x-user-id": userData?.id,
        "x-user-name": userData?.name,
      };
      const response = await services.Whatsapp.WHATSAPP_GETTASKBYID(id, extraHeaders);
      if (response) {
        const taskData = response?.data?.data;
        setDataById(taskData);
        // Direct URL opens (e.g. Ticket Ref link from admin) carry no router
        // state, so selectedMail is null and the email never loads. Seed it
        // from the fetched task.
        if (taskData?.taskType == "Gmail" && taskData?.gmailMessageId) {
          setSelectedMail((prev) => (prev && prev.id ? prev : taskData));
        }
        if (taskData?.taskType == "Gmail") {
          setEmail(extractEmailAddress(taskData?.Email?.sentTo) || "");
          setIsEmailappTask(true);
          setIsWhatsappTask(false);
          setChildTask(taskData?.childTasks[0]);
          setGetAllChildTask(taskData?.childTasks);
        }

        hasFetchedTaskRef.current = true;
        return taskData;
      }
    } catch (error) {
      console.error("Error fetching task mails:", error);
    } finally {
      // Resolves the loading gate whether the fetch succeeded or failed, so the
      // page never spins forever — a failed fetch just falls through to the
      // (empty) detail layout instead of blocking it.
      setIsPageLoading(false);
    }
    return null;
  };

  useEffect(() => {
    if (selectedtaskID && !hasFetchedTaskRef.current) {
      getTaskById(selectedtaskID);
    }
  }, [selectedtaskID, id]);

  useEffect(() => {
    const resolveTaskFromRoute = async () => {
      if (!id || selectedtaskID) return;
      const resolvedTask = await getTaskById(id);
      if (resolvedTask?.id) {
        setSelectedtaskID(resolvedTask.id);
        setCurrentTaskId(resolvedTask.id);
      }
    };

    resolveTaskFromRoute();
  }, [id, selectedtaskID]);

  useEffect(() => {
    if (supportIdParam) {
      setSelectedTab("CONVERSATION");
    }
  }, [supportIdParam]);

  const handleMessageSaved = useCallback((message) => {
    lastMessageRef.current = message;

    setChatData((prevChatData) => {
      const messageExists = prevChatData?.some((msg) => msg.id === message.id);
      if (messageExists) {
        return prevChatData;
      }

      if (message.messageSendBy === senderByRef.current) {
        setSendingMessages((prev) => {
          const newSet = new Set(prev);
          newSet.delete(message.id);
          return newSet;
        });
      } else {
      }

      const updatedChatData = [...(prevChatData || []), message];
      return updatedChatData.sort((a, b) => {
        const timeA = a.time || a.lastSeen || a.createdAt || 0;
        const timeB = b.time || b.lastSeen || b.createdAt || 0;
        return timeA - timeB;
      });
    });

    if (messageRefreshTimeoutRef.current) {
      clearTimeout(messageRefreshTimeoutRef.current);
    }
    messageRefreshTimeoutRef.current = setTimeout(() => {
      if (dataById?.taskType !== "Whatsapp") {
        getAllTaskContact();
      }
      else {
        getChatById(dataById?.contactId || contactIdRef.current);
      }

      // if (contactIdRef.current) {
      //   getChatById(contactIdRef.current);
      // }
    }, 2000);
  }, []);

  const handleWhatspp = async (message) => {
    if (!selectedContact && !selectedGroupContacts.value) {
      toast.error("Please select a contact or group first!");
      return;
    }

    const timestamp = Math.floor(Date.now() / 1000);
    const tempMessageId = `local-${Date.now()}`;
    const isGroupMessage = !!selectedGroupContacts?.value;
    const baseData = {
      id: tempMessageId,
      message,
      clientId: isGroupMessage ? groupSenderBy?.clientId : clientId,
      time: timestamp,
      type: "text",
      lastSeen: timestamp,
    };

    if (isGroupMessage) {
      baseData.groupId = selectedGroupContacts?.id || null;
      baseData.isGroup = true;
      baseData.messageSendBy = groupSenderBy?.contact || null;
      baseData.messageRecivedBy = selectedGroupContacts?.id || null;
    } else {
      baseData.messageSendBy = senderBy;
      baseData.messageRecivedBy = recivedBy;
    }

    let captionUsedInImage = false;

    if (selectedImages && selectedImages.length > 0) {
      const formData = new FormData();
      selectedImages.forEach((file) => formData.append("files", file));
      const contactNumber = selectedContact?.contactNo;
      const captionDetails = isGroupMessage ? message : message;
      const to = isGroupMessage ? selectedGroupContacts.value : contactNumber;
      if (!to) {
        toast.error("Contact or group not selected for attachment.");
        return;
      }

      const finalSessionId = isGroupMessage
        ? sessionId
        : selectedContact?.Profile?.clientId;
      if (!finalSessionId) {
        toast.error("Session ID not found.");
        return;
      }
      formData.append("sessionId", finalSessionId);
      formData.append("to", to);
      formData.append("caption", captionDetails);
      if (isGroupMessage) {
        formData.append("groupId", baseData?.groupId);
        formData.append("isGroup", baseData?.isGroup);
      }

      try {
        const uploadRes = await services.Whatsapp.ADD_WHATSAAP_ATTACHMENT(
          formData
        );
        const uploadedFiles = uploadRes?.data?.files || [];

        uploadedFiles.forEach((file) => {
          const imageMessage = {
            id: `img-${Date.now()}`,
            clientId,
            time: Math.floor(Date.now() / 1000),
            type: "image",
            imageUrl: file.url,
            caption: message || "",
          };

          if (isGroupMessage) {
            imageMessage.groupId = selectedGroupContacts.value;
            imageMessage.isGroup = true;
          } else {
            imageMessage.messageSendBy = senderBy;
            imageMessage.messageRecivedBy = recivedBy;
          }
          addMessageToChat(imageMessage);
        });

        captionUsedInImage = !!message?.trim();
      } catch (uploadErr) {
        console.error("Error uploading files:", uploadErr);
        toast.error("Failed to upload images.");
        return;
      } finally {
        setSelectedImages([]);
      }
    }

    if (captionUsedInImage) {
      return;
    }

    if (message?.trim()) {
      setSendingMessages((prev) => new Set(prev).add(tempMessageId));
      addMessageToChat(baseData);
      socket.emit("newMessage", baseData);

      try {
        await services.Whatsapp.WHATS_APP_EMAIL_SEND(baseData);

        setSendingMessages((prev) => {
          const newSet = new Set(prev);
          newSet.delete(tempMessageId);
          return newSet;
        });
        if (dataById?.taskType == 'Whatsapp') {
          getChatById(dataById?.contactId)
        }
        else {
          getAllTaskContact();

        }
      } catch (err) {
        console.error(err, "err");
        toast.error("Failed to send message.");
        setChatData(
          (prevChatData) =>
            prevChatData?.filter((msg) => msg.id !== tempMessageId) || []
        );
      }
    }
  };
  const handleContactSelect = (contact) => {
    setChatData([]);
    setSendingMessages(new Set());
    if (contact && contact.id) {
      setSelectedGroupContacts({
        value: contact.id,
        label: contact.name,
        id: contact.contactNo,
      });
      setSelectedContact(null);
      setSelectedContacts(null);
      getChatById(contact.id, true);
      getAllTaskContact();
    } else {
      setSelectedContacts(contact);
      setSelectedGroupContacts([]);
      if (contact && contact.id) {
        getChatById(contact.id, false);
      }
    }
  };

  const getChatById = async (id, isGroup = false) => {
    if (!id) return;

    try {
      const response = await services.Whatsapp.GET_CHAT_BYID_WHATSAPP(
        id,
        isGroup
      );

      if (response?.data?.data) {
        const chatHistory = response.data.data.Chats || [];
        setChatData(chatHistory);
        setSelectedContact(response?.data?.data);

        if (isGroup) {
          setGroupSenderBy(response.data.data.Profile);
        } else {
          setRecivedBy(response?.data?.data?.contactNo?.replace(/\D/g, ""));
          setSenderBy(
            response?.data?.data?.Profile?.contact?.replace(/\D/g, "")
          );
          setClientId(response?.data?.data?.Profile?.clientId);
          setProfileId(response?.data?.data?.contactNo);
        }
      } else {
        setChatData([]);
      }
    } catch (e) {
      console.error("Error fetching chat:", e);
      setChatData([]);
    }
  };

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    if (tab === "GMAIL") {
      setSelectedEmail({ email });
    }
  };

  const extractEmailAddress = (emailString) => {
    if (!emailString) return "";
    const match = emailString.match(/<([^>]+)>/);
    if (match) {
      return match[1];
    }
    return emailString;
  };
  const [childTaskData, setChildTask] = useState([]);
  const [getAllChildTask, setGetAllChildTask] = useState([]);

  const [allSelectedEmail, setAllSelectedEmail] = useState(null);

  const handlegetMessage = async () => {
    try {
      await services.Whatsapp.GET_WHATSAPP_MESSAGE();
    } catch (error) {
      console.error("Error", error);
    }
  };

  const contactIdRef = useRef(null);
  const handleClearState = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setGender("");
    setPhone("");
    setNationality("");
    setPreExistingMedicalConditions("");
  };

  const handleSubmitTraveller = async (item, optionselected) => {
    const data = {
      firstName,
      lastName,
      email,
      gender,
      phoneNumber: phone,
      Nationality: nationality,
      medicalConditions: preExistingMedicalConditions,
      taskId: id,
    };

    try {
      const result = await services.Whatsapp.Travel_Contact(data);
      if (result?.status === 201 && item === "traveller") {
        toast.success(result?.data?.message);
      }

      if (activeTab === "group") {
        const groupData = {
          contactId: [optionselected.value],
          taskId: selectedtaskID,
        };
        await services.task.CREATE_CONTACT_TASK(groupData);
      } else {
        const contactToUse = optionselected || selectedContacts;
        if (contactToUse) {
          const contactData = {
            contactId:
              item === "contact-change"
                ? [optionselected?.value]
                : item === "contact"
                  ? [optionselected?.id]
                  : [optionselected?.value],
            taskId: selectedtaskID,
          };
          await services.task.CREATE_CONTACT_TASK(contactData);
        }
      }

      if (isEmailappTask) {
        getTaskById(id);
        getAllTaskContact();
      } else {
        getAllTaskContact();
        getChatById(id);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getAllProfileWhatsapp = async () => {
    try {
      const response = await services.Whatsapp.GET_PROFILE_WHATSAPP();

      if (response?.data) {
        const profileOptions = response?.data?.map((profile) => ({
          value: profile.id,
          label: profile.name || profile.profile,
          clientId: profile.clientId,
        }));

        setWhatsappProfile(profileOptions);
        const defaultProfile = profileOptions && profileOptions[0];
        setSessionId(defaultProfile.clientId);
        await handleProfileChange(defaultProfile);
      }
    } catch (err) {
      console.error(err, "err");
    }
  };

  const getAllTaskContact = async () => {
    if (!selectedtaskID) return;
    try {
      const response = await services.task.GET_TASK_CONTACT_BY_ID(
        selectedtaskID
      );

      const data = response?.data?.data[0]?.Contact;

      setTaskData(response?.data?.data);
      setSelectedContactData(response?.data?.data);

      const contactIds = response?.data?.data
        ?.map((item) => item.contactId)
        .filter(Boolean);

      if (!selectedContacts?.value && !isAddingContact) {
        if (data) {
          const contactObject = {
            value: data.id,
            label:
              data.name || data.contactNo?.split("@")[0] || "Unknown Contact",
          };
        } else if (contactIds && contactIds.length > 0 && contacts.length > 0) {
          const foundContact = contacts.find((contact) =>
            contactIds.includes(contact.value)
          );
          if (foundContact) {
          }
        }
      }
      setSelectedContact(response.data.data[0]?.Contact);
      if (
        response?.data?.data &&
        response.data.data.length > 0 &&
        !selectedContact
      ) {
        const firstContact = response.data.data[0]?.Contact;
        if (firstContact) {
          setSelectedContact(firstContact);

          if (firstContact.contactId) {
            getChatById(firstContact.contactId);
          }
        }
      }

      setChatData((prevChatData) => {
        const serverChats = data?.Chats || [];
        const localMessages = prevChatData || [];

        const existingMessages = new Map();

        serverChats.forEach((serverMsg) => {
          const key = serverMsg.id || `${serverMsg.message}-${serverMsg.time}`;
          if (!existingMessages.has(key)) {
            existingMessages.set(key, serverMsg);
          }
        });

        const mergedChats = Array.from(existingMessages.values()).sort(
          (a, b) => {
            const timeA = a.time || a.lastSeen || a.createdAt || 0;
            const timeB = b.time || b.lastSeen || b.createdAt || 0;

            if (timeA === timeB) {
              return 0;
            }

            return timeA - timeB;
          }
        );

        return mergedChats;
      });

      setRecivedBy(data?.contactNo?.replace(/\D/g, ""));
      setSenderBy(data?.Profile?.contact?.replace(/\D/g, ""));
      setClientId(data?.Profile?.clientId);
      setProfileId(data?.contactNo);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const handleContactChange = async (selectedOption) => {
    if (!selectedprofiles || !selectedprofiles.value) {
      toast.error("Please select a profile first!");
      return;
    }
    setSelectedContacts(selectedOption);
    handleSubmitTraveller("contact-change", selectedOption);

    getAllTaskContact();
  };

  const handleProfileChange = async (selectedOptions) => {
    if (selectedOptions?.clientId) {
      setSessionId(selectedOptions.clientId);
    }
    setSelectedProfiles(selectedOptions);
    const id = selectedOptions?.value;
    try {
      const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(id);
      if (response?.data) {
        const contactOptions = response?.data?.data?.Contacts?.map(
          (contact) => ({
            value: contact.id,
            label: contact.name || contact.contactNo,
          })
        );
        setContacts(contactOptions);

        if (!selectedContacts?.value) {
        }
      }

      const responsegroup =
        await services.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(id);

      if (responsegroup?.data) {
        const groupOptions = responsegroup?.data?.data?.Contacts?.map(
          (group) => ({
            value: group.id,
            label: group.name,
            id: group?.contactNo,
          })
        );
        setGroupContacts(groupOptions);
      }
    } catch (err) {
      console.error(err, "err");
    }
  };
  const handleGroupContactChange = async (selectedOption) => {
    if (!selectedprofiles || !selectedprofiles.value) {
      toast.error("Please select a profile first!");
      return;
    }
    const groupAsContact = {
      id: selectedOption.value,
      name: selectedOption.label,
      contactNo: selectedOption.id,
    };

    handleContactSelect(groupAsContact);

    handleSubmitTraveller("contact-change", selectedOption);
  };

  const handleContactAdded = async (newContact) => {
    try {
      setIsAddingContact(true);
      if (selectedprofiles?.value) {
        let matchedContact = null;
        let attempts = 0;
        while (!matchedContact && attempts < 5) {
          const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(
            selectedprofiles?.value
          );
          const allFreshContacts = response?.data?.data?.Contacts || [];

          const contactOptions = allFreshContacts.map((contact) => ({
            value: contact.id,
            label: contact.name || contact.contactNo,
          }));
          setContacts(contactOptions);

          matchedContact = allFreshContacts.find((item) =>
            item?.contactNo?.includes(newContact.value)
          );

          if (matchedContact) {
            setSelectedContacts({
              value: matchedContact.id,
              label: matchedContact.name || matchedContact.contactNo,
            });
            setSelectedContact(matchedContact);

            await handleSubmitTraveller("contact", matchedContact);

            await getChatById(matchedContact.id);

            break;
          }

          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }

        if (!matchedContact) {
        }

        await getAllTaskContact();
      }
    } catch (error) {
      console.error("Error handling contact addition:", error);
      toast.error("Failed to add contact to selection. Please try again.");
    } finally {
      setIsAddingContact(false);
    }
  };

  useEffect(() => {
    if (selectedContact && contacts.length > 0) {
      const stillExists = contacts.find((c) => c.value === selectedContact.id);
      if (stillExists) {
        setSelectedContacts(stillExists);
      }
    }
  }, [selectedContact, contacts]);
  const handleGroupAdded = async (newGroup) => {
    try {
      if (selectedprofiles?.value) {
        const response =
          await services.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(
            selectedprofiles.value
          );
        if (response?.data) {
          const groupOptions = response?.data?.data?.Contacts?.map((group) => ({
            value: group.id,
            label: group.name,
          }));
          setGroupContacts(groupOptions);

          setSelectedGroupContacts(newGroup);

          toast.success(`Group "${newGroup.label}" has been selected!`);
        }
      }
    } catch (error) {
      console.error("Error refreshing groups:", error);
    }
  };

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  // For an Outlook-synced message, this endpoint round-trips to Microsoft Graph
  // live rather than reading a cached copy, so it can take several seconds.
  // Tracks the in-flight id so a slow, stale response from a since-abandoned
  // email selection can't overwrite the currently selected one's content.
  const emailDetailsRequestIdRef = useRef(null);
  const handlegetEmailDetails = async (id) => {
    if (!id) return;
    emailDetailsRequestIdRef.current = id;
    setEmailBodyLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/email/getEmailBy/${id}`
      );
      if (emailDetailsRequestIdRef.current !== id) return;
      setgetEmailData(response?.data);
      setSelectedEmail(response?.data);
      setThreadData(response?.data?.SubEmails);
      setSelectedEmailID(response?.data?.id);
      fetchLabels(response?.data?.id)

      if (response?.data?.SubEmails || response?.data) {
        const sanitizedEmails = response.data.SubEmails;
        const mainAttachments = response?.data?.attachmentPaths || [];
        const subEmailAttachments = (response?.data?.SubEmails || []).flatMap(
          (sub) => sub.attachmentPaths || []
        );

        const mergedAttachments = [...mainAttachments, ...subEmailAttachments];

        setMergedArray(mergedAttachments);

        setFormattedBody(sanitizedEmails);
        setAttachmentPath(response?.data);
      }

      const decodedHtml = decodeHtml(response?.data?.body);
      const cleanHtml = DOMPurify.sanitize(decodedHtml);
      setMailContent({ ...response?.data, body: cleanHtml });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      if (emailDetailsRequestIdRef.current === id) {
        setEmailBodyLoading(false);
      }
    }
  };

  const [allEmailAttachments, setAllEmailAttachments] = useState([]);

  const [attachmentApiData, setAttachmentApiData] = useState(null);

  const attachmentFileMeta = (path) => {
    const fullName = String(path || "").split("/").pop();
    const fileName = fullName?.includes("_")
      ? fullName.substring(fullName.lastIndexOf("_") + 1)
      : fullName;
    const fileExt = fileName.split(".").pop()?.toLowerCase() || "";
    return { fileName, fileExt };
  };

  const toEmailEntries = (item) =>
    (item?.attachmentPaths || []).map((path) => ({
      path,
      source: "GMAIL",
      date: item?.createdAtEmail || item?.fetchedAtSubEmail || item?.date || item?.createdAt || item?.fetchedAt || null,
    }));

  // Every email on the ticket (API list + currently loaded thread), deduped by path.
  const emailAttachmentEntries = (() => {
    const items = [
      ...(attachmentApiData?.emailAttachments || []),
      ...(attachmentApiData?.subEmailAttachments || []),
      ...(getemailbyid && typeof getemailbyid === "object" ? [getemailbyid] : []),
      ...(Array.isArray(threadData) ? threadData : []),
    ];
    const seen = new Map();
    items.flatMap(toEmailEntries).forEach((e) => {
      const prev = seen.get(e.path);
      if (!prev || (!prev.date && e.date)) seen.set(e.path, e);
    });
    return [...seen.values()];
  })();

  const whatsappAttachmentEntries = (chatData || []).flatMap((item) =>
    (item?.attachementPath || []).map((path) => ({
      path,
      source: "WHATSAPP",
      date: item?.createdAt || (item?.time ? item.time * (item.time < 1e12 ? 1000 : 1) : null),
    }))
  );

  const uploadAttachmentEntries = (Array.isArray(showAllAttachment) ? showAllAttachment : [])
    .filter((f) => f && f.finalName)
    .map((f) => ({ path: f.finalName, source: "UPLOAD", date: f.date || null }));

  const allAttachmentEntries = [
    ...emailAttachmentEntries,
    ...whatsappAttachmentEntries,
    ...uploadAttachmentEntries,
  ];

  const renderGroupedAttachments = (entries) => {
    if (!entries || entries.length === 0) {
      return <span className="text-gray-500">No attachments</span>;
    }
    const groups = {};
    entries.forEach((e) => {
      const d = e.date ? new Date(e.date) : null;
      const valid = d && !isNaN(d.getTime());
      const key = valid
        ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
        : "unknown";
      (groups[key] = groups[key] || []).push({ ...e, ts: valid ? d.getTime() : 0 });
    });
    const keys = Object.keys(groups).sort((a, b) =>
      a === "unknown" ? 1 : b === "unknown" ? -1 : b.localeCompare(a)
    );
    const fileIcons = {
      pdf: (
        <img
          src="https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
          alt="PDF"
          style={{ width: 24, height: 28 }}
        />
      ),
      doc: "📝",
      docx: "📝",
      default: "📎",
    };
    return (
      <div className="overflow-y-auto pr-2" style={{ height: "100vh", marginTop: "10px" }}>
        {keys.map((key) => (
          <div key={key}>
            <div className="text-xs font-semibold text-gray-600 mb-2 mt-3">
              {key === "unknown"
                ? "Date unknown"
                : new Date(groups[key][0].ts).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
            </div>
            {groups[key]
              .sort((a, b) => b.ts - a.ts)
              .map((e, idx) => {
                const { fileName, fileExt } = attachmentFileMeta(e.path);
                const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${e.path}`;
                const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExt);
                const icon = fileIcons[fileExt] || fileIcons.default;
                return (
                  <div
                    key={`${key}-${idx}-${e.path}`}
                    className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      {isImage ? (
                        <img
                          src={fileUrl}
                          alt={fileName}
                          className="w-10 h-10 rounded-md object-cover border border-gray-300"
                        />
                      ) : (
                        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                          {icon}
                        </div>
                      )}
                      <span
                        className="truncate max-w-[140px] font-medium text-gray-800 text-sm"
                        title={fileName}
                      >
                        {fileName}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition"
                        style={{ textDecoration: "none" }}
                      >
                        Preview
                      </a>
                      <button
                        onClick={() => downloadFile(fileUrl, fileName)}
                        className="bg-[#4CAF50] hover:bg-[#3c8c41] text-white px-3 py-1 rounded text-xs font-semibold transition"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        ))}
      </div>
    );
  };

  const getAllAttachmentData = async (id) => {
    try {
      const response = await services.Whatsapp.GET_ALL_ATTACHMENT(id);
      const responseData = response?.data?.data;
      setAttachmentApiData(responseData || null);
      const emailPaths = (responseData?.emailAttachments || []).flatMap(
        (item) => item?.attachmentPaths || []
      );
      const subEmailPaths = (responseData?.subEmailAttachments || []).flatMap(
        (item) => item?.attachmentPaths || []
      );

      const whatsappPaths = (chatData || []).flatMap(
        (item) => item?.attachementPath || []
      );

      const allPaths = [...emailPaths, ...subEmailPaths, ...whatsappPaths];

      setAllEmailAttachments(emailPaths);

      setAllAttachmentPathData(allPaths);

      return response;
    } catch (error) {
      console.error("Error fetching attachment data:", error);
      return null;
    }
  };

  const combinedAttachments = [
    ...(Array.isArray(allattachmentsPathData) ? allattachmentsPathData : []),
    ...(Array.isArray(showAllAttachment) ? showAllAttachment : []),
  ];

  const hasFetchedProfileRef = useRef(false);
  useEffect(() => {
    // getAllProfileWhatsapp only feeds the WHATSAPP chat tab and the SENDER DETAILS
    // profile/contact pickers — it used to fire unconditionally on mount even when
    // opening straight into the (default) GMAIL tab. Defer it until one of those
    // tabs is actually selected, and only fetch it once.
    if (hasFetchedProfileRef.current) return;
    if (selectedTab !== "WHATSAPP" && selectedTab !== "SENDER DETAILS") return;
    hasFetchedProfileRef.current = true;
    getAllProfileWhatsapp();
  }, [selectedTab]);

  useEffect(() => {
    // handlegetMessage();
    if (dataById?.taskType !== 'Whatsapp') {
      getAllTaskContact();

    }

    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, [id]);


  const fetchData = async (taskId) => {
    try {
      let queryString = "";
      if (isEmailappTask) {
        queryString = `email=${email}`;
      }
      if (isWhatsappTask) {
        const phoneNumber = String(phone).replace(/\D/g, "");
        queryString = `phone=${phoneNumber}`;
      }

      const response = await services.task.GET_TRAVEL_BY_TASK(
        taskId,
        queryString
      );
      const travelDetails = response?.data?.data;

      setEmail(travelDetails?.email);
      setPhone(travelDetails?.phoneNumber);
      setFirstName(travelDetails?.firstName);
      setLastName(travelDetails?.lastName);
      setNationality(travelDetails?.Nationality);
      setPreExistingMedicalConditions(travelDetails?.medicalConditions);
    } catch (error) {
      console.error("Error fetching task mails:", error);
    }
  };

  useEffect(() => {
    if (selectedtaskID) {
      fetchData(selectedtaskID);
    }
  }, [selectedtaskID, isEmailappTask, isWhatsappTask]);
  useEffect(() => {
    // Only fetches to resolve the task's WhatsApp profile once per ticket —
    // guarded so it doesn't refire (and re-hit the API) when unrelated state
    // like contacts/groupContacts/activeTab changes, or once a profile is set.
    if (!selectedtaskID || whatsappprofile.length === 0 || selectedprofiles?.value) {
      return;
    }

    let cancelled = false;
    const setSelectedContactsFromTask = async () => {
      try {
        const response = await services.task.GET_TASK_CONTACT_BY_ID(
          selectedtaskID
        );
        if (cancelled) return;

        const data = response?.data?.data[0]?.Contact;

        if (data?.Profile) {
          const profileOption = whatsappprofile.find(
            (profile) => profile.value === data.Profile.id
          );

          if (profileOption) {
            setSelectedProfiles(profileOption);
          }
        }
      } catch (error) {
        console.error("Error fetching task contacts for selection:", error);
      }
    };

    setSelectedContactsFromTask();
    return () => { cancelled = true; };
  }, [selectedtaskID, whatsappprofile, selectedprofiles?.value]);

  const selectedUserId = useMemo(() => {
    return childTaskData?.Email?.gmailMessageId
      ? childTaskData.Email.gmailMessageId
      : selectedEmail?.gmailMessageId || selectedEmailData;
  }, [childTaskData, selectedEmail, selectedEmailData]);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedUserId || isSend) {
        await handlegetEmailDetails(selectedUserId);
      }
    };

    fetchData();
  }, [selectedUserId, isSend]);
  useEffect(() => {
    if (attachmentTab) {
      getAllAttachmentData(id);
    }
  }, [attachmentTab, selectedTab]);

  useEffect(() => {
    if (selectedTab === "GMAIL") {
      setSelectedEmail(selectedMail || {});
    }
  }, [selectedTab, selectedMail]);

  useEffect(() => {
    if (!chatContainerRef.current) return;
    const chatContainer = chatContainerRef.current;

    const scrollToBottom = () => {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight,
        behavior: "smooth",
      });
    };

    const isNearBottom =
      chatContainer.scrollHeight -
      chatContainer.scrollTop -
      chatContainer.clientHeight <
      100;

    if (isNearBottom || shouldAutoScroll || chatContainer.scrollTop === 0) {
      const imgs = chatContainer.querySelectorAll("img");
      let pending = imgs.length;

      if (pending === 0) {
        scrollToBottom();
      } else {
        let loadedCount = 0;
        imgs.forEach((img) => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === pending) scrollToBottom();
          } else {
            img.addEventListener(
              "load",
              () => {
                loadedCount++;
                if (loadedCount === pending) scrollToBottom();
              },
              { once: true }
            );
          }
        });
      }
    }
  }, [chatData, shouldAutoScroll, selectedTab]);

  useEffect(() => {
    // `socket` is a shared, app-wide singleton (autoConnect: true — see
    // src/socket.js), not something owned by this page. Forcing a
    // disconnect+reconnect here on every ticket open/switch was dropping the
    // connection for anyone else relying on it, and re-registering these
    // listeners without fully removing the old ones on cleanup leaked a new
    // "connect"/"disconnect"/"connect_error" handler on every mount — so the
    // next real reconnect fired all the stacked handlers at once, each
    // re-hitting the API for the current ticket (compounding the more you
    // navigate). Fix: reuse stable handler refs, remove all of them on
    // cleanup, and only connect if not already connected.
    const handleConnect = () => {
      setIsSocketConnected(true);
      if (dataById?.taskType == "Whatsapp") {
        getChatById(dataById?.contactId || contactIdRef.current);
      } else {
        getAllTaskContact();
      }
    };

    const handleDisconnect = () => {
      setIsSocketConnected(false);
      setTimeout(() => {
        if (!socket.connected) {
          socket.connect();
        }
      });
    };

    const handleConnectError = (error) => {
      console.error("Socket connection error:", error);
      setIsSocketConnected(false);
    };

    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("connect_error", handleConnectError);
    socket.on("newMessage", handleMessageSaved);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("connect_error", handleConnectError);
      socket.off("newMessage", handleMessageSaved);
    };
  }, [handleMessageSaved, dataById?.taskType]);



  const [selectedDescription, setSelectedDescription] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState([
    {
      id: Date.now(),
      title: "",
      description: "",
      doesMatchSearch: true,
    },
  ]);
  const [searchText, setSearchText] = useState("");

  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");

  useEffect(() => {
    const stringifiedNotes = getLocalStorageItem("savedNotes");
    if (stringifiedNotes) {
      const savedNotes = stringifiedNotes;
      setNotes(savedNotes);
    }
  }, []);

  useEffect(() => {
    setLocalStorageItem("savedNotes", notes);
  }, [notes]);

  const handleAddNote = async () => {
    if (!newTitle && !newDescription) return;

    const object = {
      taskId: id,
      notes: newTitle,
      description: newDescription,
      userId: userData?.id,
    };

    const response = await services.internalnotes.CREATE_INTERNAL_NOTES(object);
    if (response?.status == 201) {
      toast.success(response?.data?.message);
      getAllInternalNotes(id);
    }

    setNewTitle("");
    setNewDescription("");
  };

  const handleEditNote = async (noteId, title, description) => {
    if (!title && !description) return;
    const object = { notes: title, description };
    const response = await services.internalnotes.UPDATE_INTERNAL_NOTES(noteId, object);
    if (response?.status == 200) {
      toast.success(response?.data?.message);
      getAllInternalNotes(id);
    }
  };

  const deleteNote = async (noteId) => {
    const response = await services.internalnotes.DELETE_INTERNAL_NOTES(noteId);
    if (response?.status == 200) {
      toast?.success(response?.data?.message);
      getAllInternalNotes(noteId);
    }
  };
  const getAllInternalNotes = async (id) => {
    try {
      const response = await services.internalnotes.GET_INTERNAL_NOTES(id);
      setNotes(response?.data?.data);
    } catch (err) {
      console.error(err, "err");
    }
  };
  useEffect(() => {
    getAllInternalNotes(id);
  }, [id, selectedTab, attachmentTab]);

  const handleDescriptionClick = (description) => {
    setSelectedDescription(description);
    setShowModal(true);
  };

  const [originalEmail, setOriginalEmail] = useState(null);
  const [threadMergedArray, setthreadMergedArray] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (getemailbyid && !originalEmail) {
      setOriginalEmail(getemailbyid);
    }
  }, [getemailbyid]);

  useEffect(() => {
    const subTasks = Array.isArray(getAllChildTask) ? getAllChildTask : [];
    let merged = subTasks;

    if (originalEmail) {
      const index = subTasks.findIndex(
        (item) => item?.Email?.id === originalEmail.id
      );
      if (index > -1) {
        merged = [
          subTasks[index],
          ...subTasks.slice(0, index),
          ...subTasks.slice(index + 1),
        ];
      } else {
        merged = [originalEmail, ...subTasks];
      }
      setSelectedItem((prev) => prev || merged[0]);
    }
    const uniqueMerged = merged.filter(
      (item, idx, arr) => arr.findIndex((i) => i.id === item.id) === idx
    );

    if (uniqueMerged.length > 0) {
      setthreadMergedArray(uniqueMerged);
      setSelectedItem((prev) => prev || uniqueMerged[0]);
    }
  }, [selectedMail, originalEmail, getAllChildTask]);

  useEffect(() => {
    handlegetEmailDetails(selectedItem?.gmailMessageId);
    // if (labelType == "Label") {
    //     getTaskGmailMessageUserId()

    // }
  }, [selectedItem]);
  const [labelTaskData, setLabelTaskData] = useState(null);

  // dataById is already fetched by getTaskById above (same /task/getTaskBy/{id}
  // endpoint) — this used to hit it a second time just to read .attachment,
  // racing the getTaskById effect on the same hasFetchedTaskRef guard (both
  // effects check it before either's async call resolves, so both fire).
  // Derive from the response we already have instead of refetching.
  useEffect(() => {
    if (!dataById) return;
    const attachmentList = Array.isArray(dataById?.attachment) ? dataById.attachment : [];
    setShowAllAttachment(attachmentList);
    setAllAttachmentPathData(attachmentList);
  }, [dataById]);

  useEffect(() => {
    if (!selectedtaskID) return;
    const handleCollision = (data) => {
      setCollisionWarning(
        `${data.message} Please be alert before making changes.`
      );
    };
    // Was previously never removed: cleanup called off("task-warning-...")
    // which doesn't match the "task-collision-..." event actually registered.
    gmailSocket.on(`task-collision-${selectedtaskID}`, handleCollision);
    return () => {
      gmailSocket.off(`task-collision-${selectedtaskID}`, handleCollision);
    };
  }, [selectedtaskID]);
  const downloadFile = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl, { mode: "cors" });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const contentType = response.headers.get("content-type");
      if (!contentType || contentType.includes("text") || contentType.includes("html")) {
        throw new Error("Invalid file content. The server did not return a valid file.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ File download failed:", error);
    }
  };

  const handleCopyTicketId = () => {
    const id = dataById?.id;
    if (!id) return;
    const fallbackCopy = () => {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = id;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        toast.success('Ticket ID copied to clipboard!');
      } catch (err) {
        toast.error('Failed to copy ID. Please copy manually.');
      }
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(id)
        .then(() => toast.success('Ticket ID copied to clipboard!'))
        .catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  };

  if (isPageLoading) {
    return <Loading />;
  }

  return (
    <div
      className="flex w-full max-h-[100vh] detail-page-root"
      style={{ scrollbarWidth: "none", background: '#f7f8fa', overflow: 'hidden' }}
    >
      <div className="detail-left-panel" style={{ width: '75%', maxWidth: '75%', minWidth: 0, display: 'flex', flexDirection: 'column', background: '#fff', borderRight: '1px solid #e9ecef', overflow: 'hidden' }}>
        {collisionWarning && (
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-2 rounded relative mb-3 flex items-center gap-2">
            <span className="inline-block bg-yellow-500 text-white text-xs font-bold px-2 py-1 rounded">
              Warning
            </span>
            <span>{collisionWarning}</span>
            <button
              className="ml-auto text-yellow-700 hover:text-yellow-900 font-bold"
              onClick={() => setCollisionWarning(null)}
            >
              ✕
            </button>
          </div>
        )}
        {/* tab bar */}
        <div className="detail-tab-bar" style={{ position: isAbsolute ? "absolute" : "static" }}>
          <button className="detail-back-btn" onClick={() => { if (AllMail) { navigate("/app", { state: { activeButton: "all-mail", AllMailPage } }); return; } else if (isLabel == "Label") { navigate("/app", { state: { isLabel: true, labelID: selectedLabelId } }) } else { navigate("/kanban") } }} title="Go back">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
          </button>
          <div className="luxe-booking-tabs luxe-booking-tabs--plain detail-tab-strip">
            <button className={`create-booking-tab ${selectedTab === "GMAIL" ? "is-active" : ""}`} onClick={() => handleTabChange("GMAIL")}>Gmail</button>
            <button className={`create-booking-tab ${selectedTab === "WHATSAPP" ? "is-active" : ""}`} onClick={() => handleTabChange("WHATSAPP")}>WhatsApp{selectedTab === "WHATSAPP" && (<span className={`ml-1.5 inline-block w-1.5 h-1.5 rounded-full ${isSocketConnected ? "bg-green-500" : "bg-red-400"}`} title={isSocketConnected ? "Socket Connected" : "Socket Disconnected"} />)}</button>
            <button className={`create-booking-tab ${selectedTab === "CONVERSATION" ? "is-active" : ""}`} onClick={() => handleTabChange("CONVERSATION")}>Ticket Chat</button>
            <button className={`create-booking-tab ${selectedTab === "INTERNAL NOTES" ? "is-active" : ""}`} onClick={() => handleTabChange("INTERNAL NOTES")}>Internal Notes</button>
            <button className={`create-booking-tab ${selectedTab === "All" ? "is-active" : ""}`} onClick={() => handleTabChange("All")}>All</button>
            <button className={`create-booking-tab ${selectedTab === "SENDER DETAILS" ? "is-active" : ""}`} onClick={() => handleTabChange("SENDER DETAILS")}>Sender Details</button>
            <button className={`create-booking-tab ${selectedTab === "ATTACHEMENT" ? "is-active" : ""}`} onClick={() => handleTabChange("ATTACHEMENT")}>Attachments</button>
          </div>

          {navContext && navTotal > 0 && (
            <div className="detail-nav-group">
              <div className="detail-nav-pill">
                <span className="detail-nav-position">
                  {navLoading && navIndex === -1 ? "…" : `${navIndex + 1} of ${navTotal}`}
                </span>
                <button
                  className="detail-nav-circle-btn"
                  onClick={goToPreviousTicket}
                  disabled={navIndex <= 0}
                  title="Previous ticket"
                >
                  <FiChevronLeft size={16} />
                </button>
                <button
                  className="detail-nav-circle-btn"
                  onClick={goToNextTicket}
                  disabled={navIndex === -1 || navIndex >= navTotal - 1}
                  title="Next ticket"
                >
                  <FiChevronRight size={16} />
                </button>
              </div>
              <button
                className="detail-nav-save-btn"
                onClick={handleSaveAndNext}
                disabled={navIndex === -1 || navIndex >= navTotal - 1}
                title="Save and go to next ticket"
              >
                Save &amp; Next
              </button>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', padding: '6px 16px' }}>
          <div
            onClick={handleCopyTicketId}
            title={dataById?.id || ''}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '700', color: '#b45309', cursor: dataById?.id ? 'pointer' : 'default', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px', padding: '4px 10px' }}
          >
            <span>Ticket ref</span>
            <span style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textTransform: 'uppercase' }}>
              {dataById?.id ? dataById.id.slice(0, 6).toUpperCase() : '—'}
            </span>
            <FiCopy size={14} />
          </div>
        </div>

        <div className="">
          {selectedTab === "GMAIL" && (
            <div className="  ">
              <MailInbox
                handleClick={handleClick}
                selectedEmailData={selectedEmail}
                deadlineDate={deadlineDate}
                dataById={dataById}
                taskDetails={taskDetails}
                setgetEmailData={setgetEmailData}
                getemailbyid={getemailbyid}
                threadData={threadData}
                formattedBody={formattedBody}
                setFormattedBody={setFormattedBody}
                mailContent={mailContent}
                setMailContent={setMailContent}
                handlegetEmailDetails={handlegetEmailDetails}
                attachmentPaths={attachmentsPath}
                decodeHtml={decodeHtml}
                setSelectedEmailData={setSelectedEmailData}
                selectedEmailId={selectedEmailData}
                setCurrentTask={setCurrentTask}
                selectedMail={selectedEmail}
                loading={loading}
                setLoading={setLoading}
                emailBodyLoading={emailBodyLoading}
                childTaskData={childTaskData}
                TaskId={id}
                selectedEmailID={selectedEmailID}
                getTaskById={getTaskById}
              />
              {composeStatus && (
                <>
                  {selectedMail?.boardId || isLabel === "Label" ? (
                    <AppModal
                      show={composeStatus}
                      onClose={() => { setComposeStatus(false); setLabelname([]); setLabelIds([]) }}
                      staticBackdrop
                      title="Compose Email"
                      subtitle="New message"
                      maxWidth="820px"
                      icon={<FiMail size={18} color="#fff" />}
                    >
                      <ComposeEmail
                        currentTaskId={currentTaskId}
                        replyDropdown={composeStatus}
                        boardId={boardId}
                        selectedMail={selectedMail}
                        setComposeStatus={setComposeStatus}
                        attachmentPaths={attachmentsPath}
                        getTaskById={getTaskById}
                        childTaskData={childTaskData}
                        taskID={id}
                        originalEmail={originalEmail}
                        boardListId={boardListId}
                        anchorEl={labelAnchorEl}
                        setLabelAnchorEl={setLabelAnchorEl}
                        setIsSend={setIsSend}
                        labelname={labelname}
                        setLabelname={setLabelname}
                        labelIds={labelIds}
                        setLabelIds={setLabelIds}
                      />
                    </AppModal>
                  ) : (
                    <Modal
                      show={composeStatus}
                      onHide={() => { setComposeStatus(false); setLabelname([]); setLabelIds([]) }}
                      size="md"
                      backdrop="static"
                      centered
                      className="p-4"
                    >
                      <Modal.Header
                        className="p-3 pt-4"
                        style={{ position: "relative" }}
                      >
                        <Modal.Title className="fs-5">
                          Please Select a Board
                        </Modal.Title>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => { setComposeStatus(false); setLabelname([]); setLabelIds([]) }}
                          style={{
                            width: "1rem",
                            height: "1rem",
                            fontSize: "0.7rem",
                          }}
                        />
                      </Modal.Header>
                      <Modal.Body className="px-4 py-3">
                        <p className="fs-6 mb-4">
                          Please select a board before composing an email.
                        </p>
                        <div className="text-end">
                          <button
                            className="btn btn-primary px-4 py-1 fs-6"
                            onClick={() => { setComposeStatus(false); setLabelname([]); setLabelIds([]) }}
                          >
                            OK
                          </button>
                        </div>
                      </Modal.Body>
                    </Modal>
                  )}
                </>
              )}
            </div>
          )}
          {selectedTab === "WHATSAPP" && (
            <div className="mt-4 rounded-[6px] w-full">
              <WhatsApps
                onSendMessage={handleWhatspp}
                chatData={chatData}
                profileId={profileId}
                getChatById={getChatById}
                selectedMail={selectedMail?.contactId}
                chatContainerRef={chatContainerRef}
                isSocketConnected={isSocketConnected}
                sendingMessages={sendingMessages}
                taskData={taskData}
                onContactSelect={handleContactSelect}
                selectedContact={selectedContact}
                selectedGroupContacts={selectedGroupContacts}
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
                loading={loading}
              />
            </div>
          )}

          {selectedTab == "SENDER DETAILS" && (
            <div className="sender-details overflow-y-scroll h-[calc(100vh-4rem)] mt-[1rem]">
              <div className="sender-details-card">
                <h2 className="sender-details-card__title">Attached Contacts</h2>

                <div className="sender-details-field sender-details-field--profile">
                  <label className="sender-details-label">WhatsApp profile</label>
                  <Select
                    className="sender-details-react-select"
                    classNamePrefix="sender-details-select"
                    closeMenuOnSelect={true}
                    options={whatsappprofile}
                    value={selectedprofiles}
                    onChange={handleProfileChange}
                    placeholder="Select Profile"
                  />
                </div>

                <div className="sender-details-subtabs">
                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab("contact"),
                        setSelectedGroupContacts(null),
                        dispatch(whatsaapActiveTab("contact"));
                    }}
                    className={`sender-details-subtab ${activeTab === "contact" ? "is-active" : ""}`}
                  >
                    Contact
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setActiveTab("group"),
                        dispatch(whatsaapActiveTab("group"));
                    }}
                    className={`sender-details-subtab ${activeTab === "group" ? "is-active" : ""}`}
                  >
                    Group Contact
                  </button>
                </div>

                <div className="sender-details-contact-row">
                  <div className="sender-details-field sender-details-field--grow">
                    {activeTab === "contact" && (
                      <Select
                        className="sender-details-react-select"
                        classNamePrefix="sender-details-select"
                        closeMenuOnSelect={true}
                        options={contacts}
                        value={contacts?.filter((group) =>
                          selectedContactTaskData
                            ?.map((task) => task?.contactId)
                            .includes(group?.value)
                        )}
                        onChange={handleContactChange}
                        placeholder="Select Contact"
                      />
                    )}
                    {activeTab === "group" && (
                      <Select
                        className="sender-details-react-select"
                        classNamePrefix="sender-details-select"
                        closeMenuOnSelect={true}
                        options={groupContacts}
                        value={groupContacts?.filter((group) =>
                          taskData
                            ?.map((task) => task?.contactId)
                            .includes(group?.value)
                        )}
                        onChange={handleGroupContactChange}
                        placeholder="Select Group Contacts"
                      />
                    )}
                  </div>
                  {activeTab == "contact" ? (
                    <button
                      type="button"
                      onClick={() => {
                        if (!selectedprofiles || !selectedprofiles.value) {
                          toast.error("Please select a profile first!");
                          return;
                        }
                        activeTab === "contact"
                          ? setShowAddContactModal(true)
                          : setShowAddGroupModal(true);
                      }}
                      className="sender-details-add-btn"
                      title={
                        activeTab === "contact"
                          ? "Add New Contact"
                          : "Create New Group"
                      }
                    >
                      <MdAdd size={20} />
                    </button>
                  ) : null}
                </div>
              </div>

              <div className="sender-details-card">
                <h2 className="sender-details-card__title">Traveller details</h2>

                <div className="sender-details-form-grid">
                  <div className="sender-details-form-field">
                    <label htmlFor="gender" className="sender-details-label">
                      Gender
                    </label>
                    <select
                      id="gender"
                      className="sender-details-input sender-details-select-native"
                      value={gender}
                      onChange={handlegenderChange}
                    >
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="sender-details-form-field">
                    <label htmlFor="email" className="sender-details-label">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="sender-details-input"
                      value={email}
                      onChange={handleEmailChange}
                      disabled={isEmailappTask}
                    />
                  </div>
                  <div className="sender-details-form-field">
                    <label htmlFor="firstName" className="sender-details-label">
                      First Name (as per Passport)
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      className="sender-details-input"
                      value={firstName}
                      onChange={handleFirstNameChange}
                    />
                  </div>
                  <div className="sender-details-form-field">
                    <label htmlFor="phone" className="sender-details-label">
                      Phone
                    </label>
                    <input
                      type="number"
                      id="phone"
                      className="sender-details-input"
                      value={phone}
                      onChange={handlePhoneChange}
                      disabled={isWhatsappTask}
                      onKeyDown={(e) =>
                        exceptThisSymbols.includes(e.key) && e.preventDefault()
                      }
                    />
                  </div>
                  <div className="sender-details-form-field">
                    <label htmlFor="lastName" className="sender-details-label">
                      Last Name (as per Passport)
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      className="sender-details-input"
                      value={lastName}
                      onChange={handleLastNameChange}
                    />
                  </div>
                  <div className="sender-details-form-field">
                    <label htmlFor="nationality" className="sender-details-label">
                      Nationality
                    </label>
                    <input
                      type="text"
                      id="nationality"
                      className="sender-details-input"
                      value={nationality}
                      onChange={handleNationalityChange}
                    />
                  </div>
                  <div className="sender-details-form-field sender-details-form-field--full">
                    <label
                      htmlFor="preExistingMedicalConditions"
                      className="sender-details-label"
                    >
                      Pre-existing medical conditions
                    </label>
                    <textarea
                      id="preExistingMedicalConditions"
                      rows={3}
                      className="sender-details-textarea"
                      value={preExistingMedicalConditions}
                      onChange={handlePreExistingMedicalConditionsChange}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    handleSubmitTraveller("traveller", {
                      label: selectedContact?.name,
                      value: selectedContact?.id,
                    })
                  }
                  className="sender-details-save-btn"
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {selectedTab == "ATTACHEMENT" && (
            <>
              <div className="bg-white rounded-[6px] shadow-md p-4 mt-[15px]">
                <div className="luxe-booking-tabs luxe-booking-tabs--plain" style={{ paddingLeft: 0, borderBottom: "1px solid #e9ecef", marginBottom: "8px" }}>
                  <button className={`create-booking-tab ${attachmentTab === "ALL" ? "is-active" : ""}`} onClick={() => setAttachmentTab("ALL")}>All</button>
                  <button className={`create-booking-tab ${attachmentTab === "GMAIL" ? "is-active" : ""}`} onClick={() => setAttachmentTab("GMAIL")}>Gmail</button>
                  <button className={`create-booking-tab ${attachmentTab === "WHATSAPP" ? "is-active" : ""}`} onClick={() => setAttachmentTab("WHATSAPP")}>WhatsApp</button>
                  <button className={`create-booking-tab ${attachmentTab === "TASKATTACHMENT" ? "is-active" : ""}`} onClick={() => setAttachmentTab("TASKATTACHMENT")}>Uploads</button>
                </div>
                <div>
                  {["ALL", "GMAIL", "WHATSAPP"].includes(attachmentTab) && (
                    <div className="mt-2">
                      {renderGroupedAttachments(
                        attachmentTab === "ALL"
                          ? allAttachmentEntries
                          : attachmentTab === "GMAIL"
                            ? emailAttachmentEntries
                            : whatsappAttachmentEntries
                      )}
                    </div>
                  )}

                  {attachmentTab === "TASKATTACHMENT" && (
                    <>
                      {showAllAttachment && showAllAttachment.length > 0 ? (
                        <div
                          className="overflow-y-auto pr-2"
                          style={{ height: "100vh", marginTop: "10px" }}
                        >
                          {showAllAttachment.map((file, idx) => {
                            const fileName = file.finalName;

                            const fileExt = fileName
                              .split(".")
                              .pop()
                              .toLowerCase();

                            const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${fileName}`;

                            const isImage = [
                              "jpg",
                              "jpeg",
                              "png",
                              "gif",
                              "webp",
                            ].includes(fileExt);

                            const fileIcons = {
                              pdf: (
                                <img
                                  src="https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
                                  alt="PDF"
                                  className="w-6 h-6"
                                />
                              ),
                              doc: "📝",
                              docx: "📝",
                              jpg: "🖼️",
                              jpeg: "🖼️",
                              png: "🖼️",
                              default: "📎",
                            };

                            const icon =
                              fileIcons[fileExt] || fileIcons.default;

                            return (
                              <div
                                key={idx}
                                className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                              >
                                <div className="flex items-center gap-3 min-w-0">
                                  {isImage ? (
                                    <img
                                      src={fileUrl}
                                      alt={fileName}
                                      className="w-10 h-10 rounded-md object-cover border border-gray-300"
                                    />
                                  ) : (
                                    <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                                      {icon}
                                    </div>
                                  )}
                                  <span
                                    className="truncate max-w-[75px] font-medium text-gray-800 text-sm"
                                    title={fileName}
                                  >
                                    {fileName}
                                  </span>
                                  <span className="text-xs fw-bold">
                                    {file?.date
                                      ? (() => {
                                        const date = new Date(file.date);
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const year = date.getFullYear();
                                        const hours = String(date.getHours()).padStart(2, '0');
                                        const minutes = String(date.getMinutes()).padStart(2, '0');
                                        return `${day}/${month}/${year} ${hours}:${minutes}`;
                                      })()
                                      : ''}
                                  </span>

                                </div>

                                <a
                                  href={fileUrl}
                                  download={fileName}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition ml-2"
                                  style={{ textDecoration: "none" }}
                                >
                                  Preview
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <span className="text-gray-500">
                          No Task Attachment
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          {selectedTab === "INTERNAL NOTES" && (
            <InternalNotes
              taskId={currentTaskId}
              notes={notes}
              newTitle={newTitle}
              setNewTitle={setNewTitle}
              newDescription={newDescription}
              setNewDescription={setNewDescription}
              handleAddNote={handleAddNote}
              handleEditNote={handleEditNote}
              deleteNote={deleteNote}
              handleDescriptionClick={handleDescriptionClick}
            />
          )}

          {selectedTab === "CONVERSATION" && (
            <div className="w-full">
              <ConversationTab
                ticketId={dataById?.supportTicketId || supportIdParam}
                parentOrigin={parentOrigin}
                handleRefreshTask={handleRefreshTask}
              />
            </div>
          )}

          {selectedTab === "All" && (
            <MessageThread
              taskId={currentTaskId}
            />
          )}
        </div>
      </div>

      <div
        className="w-[25%] max-w-[25%] h-[100vh] overflow-y-auto"
        style={{ scrollbarWidth: "none", minWidth: 0, overflowX: 'hidden' }}
      >
        <TaskData
          isMember={isMember}
          parentOrigin={parentOrigin}
          taskItem={currentTask}
          gmailMessageID={currentTask?.gmailMessageId}
          updateTaskMail={updateTaskMail}
          setBoardListId={setBoardListId}
          getTaskMail={getTaskMail}
          setCurrentTask={setCurrentTask}
          setTaskDetailModal={setTaskDetailModal}
          setComposeStatus={setComposeStatus}
          threadData={threadData}
          setSelectedEmailData={setSelectedEmailData}
          selectedMail={selectedMail}
          setSelectedMail={setSelectedMail}
          selectedEmail={selectedEmail}
          currentTaskId={currentTaskId}
          setCurrentTaskId={setCurrentTaskId}
          handlegetEmailDetails={handlegetEmailDetails}
          getemailbyid={getemailbyid}
          selectedEmailData={selectedEmailData}
          childTaskData={childTaskData}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          threadMergedArray={threadMergedArray}
          setthreadMergedArray={setthreadMergedArray}
          originalEmail={originalEmail}
          setOriginalEmail={setOriginalEmail}
          selectedUserId={selectedUserId}
          selectedContact={selectedContact}
          formattedBody={formattedBody}
          showAllAttachment={showAllAttachment}
          setShowAllAttachment={setShowAllAttachment}
          setAllAttachmentPathData={setAllAttachmentPathData}
          refreshTrigger={refreshTrigger}
          onArchived={handleTicketArchived}
        />
      </div>

      <AddContactModal
        showModal={showAddContactModal}
        handleClose={() => setShowAddContactModal(false)}
        sessionId={sessionId}
        onContactAdded={handleContactAdded}
      />
      <LabelList
        labelname={labelname}
        setLabelname={setLabelname}
        setLabelIds={setLabelIds}
        anchorEl={labelAnchorEl}
        setAnchorEl={setLabelAnchorEl}
        selectedEmailID={selectedEmailID}
        TaskId={currentTaskId}
        isAdd={true}
        isSend={isSend}

      />
    </div >
  );
}

export default Whatsapp;
